import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import StormBuildUpTable, { StormBuildUpTableProps } from "./StormBuildUpTable";
import { getConcAttenuationRows, MAX_CONC_SECTIONS } from "../../../utils/stormBuildUpConcAttenuation";
import { COLORS } from "../../../utils/constants";

type ConcAttenuationTableProps = Omit<StormBuildUpTableProps, 'rows' | 'onDeleteSection' | 'onConfigureSection'> & {
  sectionCount: number;
  onAddTank: () => void;
  onDeleteSection: (headerId: string) => void;
  onConfigureSection: (headerId: string) => void;
  concConfigPct?: Record<string, number>;
  supplierName?: string;
  sectionTitles?: Record<string, string>;
  drawingRefs?: Record<string, string>;
};

export default function ConcAttenuationTable({ sectionCount, onAddTank, onDeleteSection, onConfigureSection, concConfigPct, supplierName, sectionTitles, drawingRefs, ...props }: ConcAttenuationTableProps) {
  return (
    <div>
      <StormBuildUpTable
        rows={getConcAttenuationRows(sectionCount, concConfigPct, supplierName, sectionTitles, drawingRefs)}
        onDeleteSection={onDeleteSection}
        onConfigureSection={onConfigureSection}
        {...props}
      />
      <div style={{ marginTop: '16px' }}>
        <Button
          type="text"
          icon={<PlusOutlined style={{ color: COLORS.primary }} />}
          onClick={onAddTank}
          disabled={sectionCount >= MAX_CONC_SECTIONS}
          style={{ color: COLORS.primary, fontWeight: 500, padding: '4px 8px' }}
        >
          Add New Tank
        </Button>
      </div>
    </div>
  );
}
